import React from 'react';
import SolutionDetail from '../components/SolutionDetail';
import MapIcon from '@mui/icons-material/Map';

const solutionData = {
  id: 'gis-mapping',
  name: 'GIS Solutions',
  icon: <MapIcon sx={{ fontSize: 60 }} />,
  description: 'Comprehensive Geographic Information System mapping and analysis services',
  overview: `Our GIS Mapping services provide comprehensive spatial data management, analysis, and visualization solutions. We utilize advanced GIS technology to create detailed maps, perform spatial analysis, and develop custom GIS applications. Our team of experienced GIS professionals helps organizations make informed decisions by transforming complex spatial data into meaningful insights.`,
  features: [
    {
      title: 'Spatial Data Management',
      description: 'Organization and maintenance of geographic databases',
    },
    {
      title: 'Custom Map Creation',
      description: 'Production of high-quality thematic and topographic maps',
    },
    {
      title: 'Spatial Analysis',
      description: 'Advanced analysis of geographic data for decision support',
    },
    {
      title: 'Data Conversion',
      description: 'Conversion between different spatial data formats',
    },
    {
      title: 'Web GIS Solutions',
      description: 'Development of web-based GIS applications',
    },
    {
      title: 'Training and Support',
      description: 'GIS training and technical support services',
    },
  ],
  benefits: [
    'Improved decision making',
    'Enhanced spatial analysis',
    'Better data visualization',
    'Efficient data management',
    'Custom mapping solutions',
    'Expert technical support',
  ],
};

const GISMapping = () => {
  return <SolutionDetail solution={solutionData} />;
};

export default GISMapping; 